export const dietLabels = [
  {
    label: "Balanced",
    value: "balanced",
    description: "Protein/Fat/Carb values in 15/35/50 ratio",
  },
  {
    label: "High-Protein",
    value: "high-protein",
    description: "More than 50% of total calories from proteins",
  },
  {
    label: "Low-Carb",
    value: "low-carb",
    description: "Less than 20% of total calories from carbs",
  },
  {
    label: "Low-Fat",
    value: "low-fat",
    description: "Less than 15% of total calories from fat",
  },
];
